import React from 'react';
import { Provider } from 'react-redux';
import Community from './components/Community';
import configureStore from './configureStore';
import { contextPropTypes } from '../../proptypes/shared';

const CommunityApp = ({ context, lists }) => {
  const store = configureStore({ context, lists, browserWindow: { mobileBrowser: context.mobileBrowser, tabletBrowser: context.tabletBrowser } });

  return (
    <Provider store={store}>
      <div id="modalPortal" />
      <Community />
    </Provider>
  );
};

CommunityApp.propTypes = {
  context: contextPropTypes.isRequired
};

export default CommunityApp;
